module.exports = require('./helpers/bundle-url').getBundleURL('cTg1t') + "logo-dark.eefe0b7f.svg";